// Leads (/leads): saldo, buscas e leads de cada busca, com conversa pelo
// NewTicketModal (fila, conexão e template já resolvidos por ele).
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import SearchIcon from "@material-ui/icons/Search";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import CancelIcon from "@material-ui/icons/Cancel";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import moment from "moment";
import { toast } from "react-toastify";
import { useTheme, alpha } from "@material-ui/core/styles";
import { v4 as uuidv4 } from "uuid";

import MainContainer from "../../components/MainContainer";
import NewTicketModal from "../../components/NewTicketModal";
import ComprarLeadsModal from "../../components/ComprarLeadsModal";
import NovaBuscaLeadsModal from "../../components/NovaBuscaLeadsModal";
import AerosConfirmModal from "../../components/AerosConfirmModal";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import useCampaignPageStyles from "../Campaigns/campaignPageStyles";
import useLeadsPageStyles from "./leadsPageStyles";
import { AEROS, stateText } from "../../styles/aerosTokens";
import {
  statusLabel, statusTone, formatMilhar, COLUNAS_LEAD, colunasVisiveis, entregaParcial,
  formatTelefone, formatNota, whatsappTone, valorColuna, linhasCsv, urlSegura,
} from "./leadsRules";

const TOM = {
  success: AEROS.success, warning: AEROS.warning, info: AEROS.cyan, danger: AEROS.error, neutral: "#9CA3B8",
};
const TOM_KEY = { success: "success", warning: "warning", info: "info", danger: "danger", neutral: "neutral" };
const LS_COLUNAS = "leadsColunas";
const LARGURA_COL = { nome: "minmax(160px,1.4fr)", telefone: "150px", temWhatsapp: "72px", email: "minmax(160px,1.2fr)", redes: "96px", endereco: "minmax(180px,1.4fr)", site: "minmax(140px,1fr)", notaGoogle: "64px", numeroAvaliacoes: "84px", linkMaps: "90px", observacoes: "minmax(200px,1.6fr)" };

const lerColunas = () => {
  try { return colunasVisiveis(JSON.parse(localStorage.getItem(LS_COLUNAS))); } catch (e) { return colunasVisiveis(null); }
};

const Leads = () => {
  const c = useCampaignPageStyles();
  const classes = useLeadsPageStyles();
  const theme = useTheme();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);
  const { setCurrentTicket } = useContext(TicketsContext);
  const isAdmin = user.profile === "admin";
  const companyId = user.companyId;

  const [saldo, setSaldo] = useState({ saldo: 0, reservado: 0, disponivel: 0 });
  const [buscas, setBuscas] = useState([]);
  const [buscaId, setBuscaId] = useState(null);
  const [leads, setLeads] = useState([]);
  const [leadsCount, setLeadsCount] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [termo, setTermo] = useState("");
  const [colunas, setColunas] = useState(lerColunas);
  const [colMenu, setColMenu] = useState(null);
  const [comprar, setComprar] = useState(false);
  const [novaBusca, setNovaBusca] = useState(false);
  const [cancelar, setCancelar] = useState(null);
  const [ticketModal, setTicketModal] = useState(false);
  const [contatoTicket, setContatoTicket] = useState({});
  const [exportando, setExportando] = useState(false);

  const carregaSaldo = useCallback(async () => {
    try { const { data } = await api.get("/leads/saldo"); setSaldo(data); } catch (err) { toastError(err); }
  }, []);
  const carregaBuscas = useCallback(async () => {
    try { const { data } = await api.get("/leads/buscas"); setBuscas(data || []); } catch (err) { toastError(err); }
  }, []);
  const carregaLeads = useCallback(async (id, pageNumber, searchParam) => {
    if (!id) { setLeads([]); setLeadsCount(0); setHasMore(false); return; }
    try {
      const { data } = await api.get(`/leads/buscas/${id}/leads`, { params: { pageNumber, searchParam } });
      setLeads((prev) => (pageNumber === 1 ? data.leads : [...prev, ...data.leads]));
      setLeadsCount(data.count); setHasMore(data.hasMore);
    } catch (err) { toastError(err); }
  }, []);

  useEffect(() => { carregaSaldo(); carregaBuscas(); }, [carregaSaldo, carregaBuscas]);
  useEffect(() => { setPagina(1); carregaLeads(buscaId, 1, termo); }, [buscaId, termo, carregaLeads]);

  useEffect(() => {
    if (!socket || !companyId) return undefined;
    const onLeads = (data) => {
      setBuscas((prev) => prev.map((b) => (b.id === data.searchId ? { ...b, quantidadeEntregue: data.entregues,
        status: data.action === "finish" ? "done" : data.action === "failed" ? "failed" : data.action === "search-start" ? "running" : b.status } : b)));
      if (data.action === "finish") {
        toast.success(i18n.t("aeros.leads.finished", { count: data.entregues }));
        carregaSaldo();
        if (data.searchId === buscaId) carregaLeads(buscaId, 1, termo);
      }
      if (data.action === "failed") { toast.error(i18n.t("aeros.leads.failedToast")); carregaSaldo(); }
      if (data.action === "progress" && data.whatsappVerificado !== undefined && data.searchId === buscaId) carregaLeads(buscaId, 1, termo);
    };
    const onRecarga = (data) => { if (data.action === "paid") carregaSaldo(); };
    socket.on(`company-${companyId}-leads`, onLeads);
    socket.on(`company-${companyId}-leads-recarga`, onRecarga);
    return () => { socket.off(`company-${companyId}-leads`, onLeads); socket.off(`company-${companyId}-leads-recarga`, onRecarga); };
  }, [socket, companyId, buscaId, termo, carregaSaldo, carregaLeads]);

  const buscaAtual = useMemo(() => buscas.find((b) => b.id === buscaId) || null, [buscas, buscaId]);
  const gridLeads = useMemo(() => `${colunas.map((k) => LARGURA_COL[k]).join(" ")} 48px`, [colunas]);
  const minWidthLeads = 120 * colunas.length + 48;

  const toggleColuna = (key) => {
    const novas = colunas.includes(key) ? colunas.filter((k) => k !== key) : [...colunas, key];
    const validas = colunasVisiveis(COLUNAS_LEAD.map((col) => col.key).filter((k) => novas.includes(k)));
    setColunas(validas);
    try { localStorage.setItem(LS_COLUNAS, JSON.stringify(validas)); } catch (e) { /* sem storage */ }
  };

  const abrirConversa = (lead) => {
    if (!lead.contactId) return;
    setContatoTicket({ id: lead.contactId, name: lead.nome, number: lead.telefone, channel: "whatsapp", active: true });
    setTicketModal(true);
  };
  const fecharTicket = (ticket) => {
    setTicketModal(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      setCurrentTicket({ id: ticket.id, uuid: ticket.uuid, code: uuidv4() });
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const fecharComprar = useCallback(() => setComprar(false), []);
  const fecharNovaBusca = useCallback(() => setNovaBusca(false), []);
  const onBuscaCriada = useCallback(() => { carregaBuscas(); carregaSaldo(); }, [carregaBuscas, carregaSaldo]);

  const handleCancelar = async () => {
    try {
      await api.post(`/leads/buscas/${cancelar.id}/cancelar`);
      toast.success(i18n.t("aeros.leads.cancelled"));
      setCancelar(null); carregaBuscas(); carregaSaldo();
    } catch (err) { toastError(err); }
  };

  const handleExport = async () => {
    if (!buscaId) return;
    setExportando(true);
    try {
      const todos = []; let p = 1; let mais = true;
      while (mais) {
        const { data } = await api.get(`/leads/buscas/${buscaId}/leads`, { params: { pageNumber: p, searchParam: termo } });
        todos.push(...data.leads); mais = data.hasMore && data.leads.length > 0; p += 1;
      }
      const blob = new Blob([linhasCsv(todos, colunas)], { type: "text/csv;charset=utf-8" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob); a.download = `leads-busca-${buscaId}.csv`; a.click();
      URL.revokeObjectURL(a.href);
    } catch (err) { toastError(err); } finally { setExportando(false); }
  };

  const pill = (status) => {
    const tone = statusTone(status);
    return (
      <span className={classes.pill} style={{ color: stateText(theme, TOM[tone], TOM_KEY[tone]), backgroundColor: alpha(TOM[tone], 0.12) }}>
        <span className={classes.pillDot} style={{ backgroundColor: TOM[tone] }} />{statusLabel(status)}
      </span>
    );
  };

  const celula = (lead, key) => {
    if (key === "temWhatsapp") {
      const t = whatsappTone(lead.temWhatsapp);
      return <Tooltip title={i18n.t(`aeros.leads.whatsapp.${t}`)}><WhatsAppIcon fontSize="small" className={t === "yes" ? classes.wppYes : t === "no" ? classes.wppNo : classes.wppUnknown} /></Tooltip>;
    }
    if (key === "redes") {
      const rede = (url, Icone, nome) => {
        const segura = urlSegura(url);
        if (!segura) return null;
        return <a className={classes.link} href={segura} target="_blank" rel="noreferrer" aria-label={nome}><Icone fontSize="small" /></a>;
      };
      return (
        <span style={{ display: "flex", gap: 4 }}>
          {rede(lead.instagram, InstagramIcon, "Instagram")}
          {rede(lead.facebook, FacebookIcon, "Facebook")}
          {rede(lead.linkedin, LinkedInIcon, "LinkedIn")}
        </span>
      );
    }
    if (key === "site") {
      const segura = urlSegura(lead.site);
      // Sem esquema http(s) o valor vira texto: link de terceiro não vira href.
      if (!segura) return lead.site || "";
      return <a className={classes.link} href={segura} target="_blank" rel="noreferrer">{segura.replace(/^https?:\/\//, "")}</a>;
    }
    if (key === "linkMaps") {
      const segura = urlSegura(lead.linkMaps);
      if (!segura) return "";
      return <a className={classes.link} href={segura} target="_blank" rel="noreferrer">{i18n.t("aeros.leads.lead.maps")}</a>;
    }
    if (key === "telefone") return formatTelefone(lead.telefone);
    if (key === "notaGoogle") return formatNota(lead.notaGoogle);
    return valorColuna(lead, key);
  };

  return (
    <MainContainer>
      <NewTicketModal modalOpen={ticketModal} initialContact={contatoTicket} onClose={fecharTicket} />
      <ComprarLeadsModal open={comprar} onClose={fecharComprar} onSaldoAtualizado={carregaSaldo} />
      <NovaBuscaLeadsModal open={novaBusca} onClose={fecharNovaBusca} disponivel={saldo.disponivel}
        onCriada={onBuscaCriada} />
      <AerosConfirmModal open={!!cancelar} onClose={() => setCancelar(null)} onConfirm={handleCancelar} tone="warning"
        icon={<CancelIcon />} title={i18n.t("aeros.leads.cancel")} description={cancelar ? `${cancelar.nicho} — ${cancelar.cidade}/${cancelar.estado}` : ""}
        confirmLabel={i18n.t("aeros.leads.cancel")} cancelLabel={i18n.t("aeros.confirm.cancel")} />

      <div className={c.pageHeader}>
        <div>
          <div className={c.pageTitle}>{i18n.t("aeros.leads.title")}</div>
          <div className={classes.headerSubtitle}>{i18n.t("aeros.leads.subtitle")}</div>
        </div>
        {isAdmin && (
          <div className={c.headerActions}>
            <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => setNovaBusca(true)}>{i18n.t("aeros.leads.newSearch")}</Button>
            <Button variant="contained" color="primary" className={c.gradientButton} startIcon={<AddShoppingCartIcon />} onClick={() => setComprar(true)}>{i18n.t("aeros.leads.buy")}</Button>
          </div>
        )}
      </div>

      <div className={c.pageBody}>
        <div className={classes.topGrid}>
          <div className={classes.saldoCard}>
            <div className={classes.saldoLabel}>{i18n.t("aeros.leads.balance")}</div>
            <div className={classes.saldoRow}><span className={classes.saldoValue}>{formatMilhar(saldo.saldo)}</span><span className={classes.saldoUnit}>{i18n.t("aeros.leads.unit")}</span></div>
            <div className={classes.saldoHint}>{i18n.t("aeros.leads.available", { count: formatMilhar(saldo.disponivel) })}{saldo.reservado > 0 && ` · ${i18n.t("aeros.leads.reserved", { count: formatMilhar(saldo.reservado) })}`}</div>
          </div>
          <div className={classes.kpiCard}><div className={classes.kpiLabel}>{i18n.t("aeros.leads.searches")}</div><div className={classes.kpiValue}>{formatMilhar(buscas.length)}</div></div>
          <div className={classes.kpiCard}><div className={classes.kpiLabel}>{i18n.t("aeros.leads.col.delivered")}</div><div className={classes.kpiValue}>{formatMilhar(buscas.reduce((s, b) => s + (b.quantidadeEntregue || 0), 0))}</div></div>
        </div>

        <div className={classes.card}>
          <div className={classes.cardHead}><div className={classes.cardTitle}>{i18n.t("aeros.leads.searches")}</div></div>
          <div className={classes.tableScroll}>
            <div className={classes.rowHead}>
              <div>{i18n.t("aeros.leads.col.niche")}</div><div>{i18n.t("aeros.leads.col.city")}</div>
              <div style={{ textAlign: "right" }}>{i18n.t("aeros.leads.col.requested")}</div>
              <div style={{ textAlign: "right" }}>{i18n.t("aeros.leads.col.delivered")}</div>
              <div>{i18n.t("aeros.leads.col.status")}</div><div>{i18n.t("aeros.leads.col.date")}</div><div />
            </div>
            {buscas.length === 0 ? <div className={classes.vazio}>{i18n.t("aeros.leads.searchesEmpty")}</div> : buscas.map((b) => (
              <div key={b.id} className={`${classes.row} ${b.id === buscaId ? classes.rowSelected : ""}`} onClick={() => setBuscaId(b.id)} role="button" tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBuscaId(b.id); } }}>
                <div className={classes.ellipsis} title={b.nicho}>{b.nicho}</div>
                <div className={classes.muted}>{b.cidade}/{b.estado}</div>
                <div className={classes.num}>{formatMilhar(b.quantidadeSolicitada)}</div>
                <div className={classes.num}>{formatMilhar(b.quantidadeEntregue)}</div>
                <div>{pill(b.status)}{(b.status === "running" || b.status === "processing") && <div className={classes.progress}>{i18n.t("aeros.leads.progress", { delivered: b.quantidadeEntregue, requested: b.quantidadeSolicitada })}</div>}</div>
                <div className={classes.muted}>{moment(b.createdAt).format("DD/MM/YYYY HH:mm")}</div>
                <div>{isAdmin && b.status === "queued" && (
                  <Tooltip title={i18n.t("aeros.leads.cancel")}><IconButton size="small" aria-label={i18n.t("aeros.leads.cancel")} onClick={(e) => { e.stopPropagation(); setCancelar(b); }}><CancelIcon fontSize="small" /></IconButton></Tooltip>
                )}</div>
              </div>
            ))}
          </div>
          {buscaAtual && entregaParcial(buscaAtual) && <div className={classes.aviso}><InfoOutlinedIcon />{i18n.t("aeros.leads.partial")}</div>}
          {buscaAtual && buscaAtual.status === "failed" && <div className={classes.aviso}><InfoOutlinedIcon />{i18n.t("aeros.leads.failedHint")}</div>}
        </div>

        <div className={classes.card}>
          <div className={classes.cardHead}>
            <div className={classes.cardTitle}>{i18n.t("aeros.leads.leadsOf")}{buscaAtual ? ` · ${buscaAtual.nicho} (${formatMilhar(leadsCount)})` : ""}</div>
            <div className={classes.cardActions}>
              <TextField size="small" variant="outlined" className={classes.searchInput} placeholder={i18n.t("aeros.leads.searchPlaceholder")}
                value={termo} onChange={(e) => setTermo(e.target.value)} inputProps={{ "aria-label": i18n.t("aeros.leads.searchPlaceholder") }} />
              <Button size="small" startIcon={<ViewColumnIcon />} onClick={(e) => setColMenu(e.currentTarget)}>{i18n.t("aeros.leads.columns")}</Button>
              <Menu anchorEl={colMenu} open={!!colMenu} onClose={() => setColMenu(null)}>
                {COLUNAS_LEAD.map((col) => (
                  <MenuItem key={col.key} className={classes.colMenuItem} onClick={() => toggleColuna(col.key)} disabled={col.key === "nome"}>
                    <Checkbox size="small" checked={colunas.includes(col.key)} />{i18n.t(col.i18n)}
                  </MenuItem>
                ))}
              </Menu>
              <Button size="small" startIcon={<GetAppIcon />} onClick={handleExport} disabled={!buscaId || exportando}>{i18n.t("aeros.leads.export")}</Button>
            </div>
          </div>
          <div className={classes.tableScroll}>
            <div className={classes.leadHead} style={{ gridTemplateColumns: gridLeads, minWidth: minWidthLeads }}>
              {colunas.map((k) => (
                <div key={k}>
                  {k === "temWhatsapp"
                    ? <Tooltip title={i18n.t("aeros.leads.lead.whatsapp")}><WhatsAppIcon fontSize="small" aria-label={i18n.t("aeros.leads.lead.whatsapp")} /></Tooltip>
                    : i18n.t(COLUNAS_LEAD.find((col) => col.key === k).i18n)}
                </div>
              ))}<div />
            </div>
            {!buscaId ? <div className={classes.vazio}>{i18n.t("aeros.leads.selectSearch")}</div>
              : leads.length === 0 ? <div className={classes.vazio}>{i18n.t("aeros.leads.leadsEmpty")}</div>
              : leads.map((lead) => (
                <div key={lead.id} className={classes.leadRow} style={{ gridTemplateColumns: gridLeads, minWidth: minWidthLeads }}>
                  {colunas.map((k) => <div key={k} className={classes.leadCell} title={typeof celula(lead, k) === "string" ? celula(lead, k) : undefined}>{celula(lead, k)}</div>)}
                  <div>
                    <Tooltip title={i18n.t("aeros.leads.openTicket")}><span>
                      <IconButton size="small" aria-label={i18n.t("aeros.leads.openTicket")} disabled={!lead.contactId || lead.temWhatsapp === false} onClick={() => abrirConversa(lead)}>
                        <WhatsAppIcon fontSize="small" />
                      </IconButton>
                    </span></Tooltip>
                  </div>
                </div>
              ))}
            {hasMore && <div className={classes.vazio}><Button size="small" onClick={() => { const p = pagina + 1; setPagina(p); carregaLeads(buscaId, p, termo); }}>{i18n.t("aeros.leads.loadMore")}</Button></div>}
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default Leads;
